import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-veteran-children-title']),
    childWithVeteran: yesNoUI({
      title: 'Do you have a child with the Veteran?',
    }),
  },
  schema: {
    type: 'object',
    properties: {
      childWithVeteran: yesNoSchema,
    },
    required: ['childWithVeteran'],
  },
};
